export const extractPhoneCode = (phone: string): string => phone.slice(0, 2);

export const extractPhoneNumber = (phone: string): string => phone.slice(2);
